
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gJIU_HsX1JbGzyhGrMyNQnPYv4eE_45qEe3HpEMcbqk_45XsMeta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexfY0J3JI0y4fTMFiW6_45SA5As5CT5bi5TnConms47Y2LMMeta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchzsgEKnyXFGsK60mxBbja4uVUS42flWAz6WX0bXzHVaMMeta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexr_puldqlXOmqlZVuWPriJPTDn_45qtvqtoJm_kD8SkO0EMeta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93ay5Wrv_45G04kz6UlEmCyt_b3UfVX2gLO8su_45IaBnqjVgMeta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexD2IZndZqUH77qOCiLP4SG3LB1jyB2HsmwXc9cYFUo78Meta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_934QUwOWHSdn5W3vhqps564f5fZLvYAUWb3XdZpM7rsnwMeta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexsyvN8NkdnNZPNgq3AsdsE_45hPQ0AengT_45VZqwGayoHiYMeta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_933k5zvv7gf4umI5Mvcg4ajw59lxvKHlVBjk2npqey3gEMeta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexqH_qgrQup_45SD9PqMovI_Al_45RmM9mrHC_45W6p2aZnig_4Meta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexA2lQPSTIO6Flan7KybgBfEb1btuItPiZ20tuWRyyfK8Meta } from "/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexD2IZndZqUH77qOCiLP4SG3LB1jyB2HsmwXc9cYFUo78Meta || {},
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexsyvN8NkdnNZPNgq3AsdsE_45hPQ0AengT_45VZqwGayoHiYMeta || {},
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexqH_qgrQup_45SD9PqMovI_Al_45RmM9mrHC_45W6p2aZnig_4Meta || {},
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexA2lQPSTIO6Flan7KybgBfEb1btuItPiZ20tuWRyyfK8Meta || {},
    component: () => import("/codebuild/output/src1734718314/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]